import React from 'react';

import Alert from '../../../../../Alert/Alert';

import { alert } from './RMFCompletedAlert.scss';

const RMFCompletedAlert: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div>
    <div className={alert}>
      <Alert variant="info">{children}</Alert>
    </div>
  </div>
);

export default RMFCompletedAlert;
